import { Stack, styled, Typography } from '@mui/material';

// -----------------------------------------------------------------------------------------

export const CustomRoot = styled(Stack)(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  position: 'relative',
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  backgroundImage: 'url(/assets/background/overlay_1.svg), url(images/fundo.jpeg)',
  backgroundAttachment: 'fixed',
  padding: theme.spacing(10, 0),
  marginTop: '30px',
  [theme.breakpoints.up('md')]: {
    height: 400,
    padding: 0,
  },
}));

export const CustomContent = styled(Stack)(() => ({
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  gap: 30,
  flexWrap: 'wrap',
  flexGrow: 1,

  '@media (max-width: 750px)': {
    gap: 70,
  },
}));

export const StyledTypography = styled(Typography)(() => ({
  color: 'text.secondary',
  textAlign: 'center',

  '@media (max-width: 750px)': {
    padding: '30px 60px',
    alignItems: 'center',
    margin: 'auto',
  },
}));
